import cookie from 'js-cookie';

export const setCookie = (key, value) => {
  console.log(value)
  if (process.browser) {
    cookie.set(key, btoa(JSON.stringify(value)), {
      expires: 1,
      path: '/'
    });
  }
};

export const removeCookie = key => {
  if (process.browser) {
    cookie.remove(key, {
      expires: 1
    });
  }
};

export const getCookie = key => {
  const cookieValue = cookie.get(key);
  let value = '';

  if (cookieValue)
    value = JSON.parse(atob(cookie.get(key)));

  return value;
}



// WEBPACK FOOTER //
// ./src/utils/session.js